import { CommentaryBoxDetail } from '@features/commentaryBox/components/CommentaryBoxDetail'
import { createFileRoute, useParams } from '@tanstack/react-router'

const CommentaryBoxDetailRoute = () => {
  const { commentaryBoxId } = useParams({
    from: '/_auth/o/$orgId/commentaryBox/$commentaryBoxId',
  })

  return <CommentaryBoxDetail commentaryBoxId={commentaryBoxId} />
}

export const Route = createFileRoute(
  '/_auth/o/$orgId/commentaryBox/$commentaryBoxId'
)({
  component: CommentaryBoxDetailRoute,
  loader: async () => ({
    crumb: 'Details',
  }),
})
